import * as React from 'react';
import { Translate } from '../../shared/LanguageService';

interface IInvoiceTypeLegendProps {
    showCredit?: boolean;
    showPastDue?: boolean;
}

const defaultProps: IInvoiceTypeLegendProps = {
    showCredit: true,
    showPastDue: true
};

const InvoiceTypeLegend = (passedInProps: IInvoiceTypeLegendProps) => {
    const props = Object.assign({}, defaultProps, passedInProps);

    return (
        <fieldset className="invoice-type-legend">
            {props.showCredit && (
                <div className="invoice-color-item">
                    <div className="invoice-credit-color-box"></div>
                    <span className="invoice-type-span">{Translate('invoice/credit')}</span>
                </div>
            )}
            {props.showPastDue && (
                <div className="invoice-color-item">
                    <div className="invoice-pastdue-color-box"></div>
                    <span className="invoice-type-span">{Translate('invoice/pastdue')}</span>
                </div>
            )}
        </fieldset>
    );
};

export default InvoiceTypeLegend;
